(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("Jeri", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["Jeri"] = factory(require("react"), require("react-dom"));
	else
		root["Jeri"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_15__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition